import {Box, Card, styled} from '@mui/material';
import {ImageContainerType, StyledCardType} from './types';

const StyledCard = styled(Card)<StyledCardType>`
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: ${({$flexDirection}) => $flexDirection ?? 'row'};
		max-width: ${({$maxWidth}) => $maxWidth ?? '852px'};
		justify-content: ${({$justifyContent}) => $justifyContent ?? 'unset'};
		align-items: center;
		margin: ${({$margin}) => $margin ?? '0 auto'};
	}
`;

const ImageContainer = styled(Box)<ImageContainerType>`
	margin-inline: ${({$noMargin}) => ($noMargin ? 0 : 'auto')};

	& img {
		max-width: 100%;
	}
`;

export {StyledCard, ImageContainer};
